import React from "react"
import { Link } from "theme-ui"
import { graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

const HeaderLogo = ({ siteTitle, logo }) => {
  const data = useStaticQuery(graphql`
    query {
      logo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          gatsbyImageData(
            height: 50
            placeholder: BLURRED
            formats: [AUTO, WEBP, AVIF]
          )
        }
      }
    }
  `)

  if (!data.logo) {
    return (
      <Link
        variant="nav"
        href="/"
        sx={{
          width: "100%",
          maxWidth: 155,
          alignItems: "center",
        }}
      >
        {siteTitle}
      </Link>
    )
  }

  const image = getImage(data.logo)

  return (
    <Link
      variant="nav"
      href="/"
      sx={{
        width: "100%",
        maxWidth: 155,
        alignItems: "center",
      }}
    >
      <GatsbyImage image={image} alt={siteTitle} />
    </Link>
  )
}

export default HeaderLogo
